import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {
  Route,
  Navigate,
  BrowserRouter,
  Routes,
  Outlet,
} from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Login from './views/Auth/Login';
import ForgotPassword from './views/Auth/ForgotPassword';
import ResetPassword from './views/Auth/ResetPassword';
import DashboardWrapper from './views/DashboardWrapper';
import Enquiries from './views/Admin/Enquiries';
import Bookings from './views/Admin/Bookings';
import Clients from './views/Admin/Clients';
import Artists from './views/Admin/Artists';
import ProcessEnquiry from './views/Admin/ProcessEnquiry';
import EditArtist from './views/Admin/EditArtist';
import EditBooking from './views/Admin/EditBooking';
import CreateBooking from './views/Admin/CreateBooking';
import Showcase from './views/Admin/Showcase';
import Styles from './views/Admin/Styles';
import Calendar from './views/Admin/Calendar';
import Songs from './views/Songs';
import MfsContent from './views/MfsContent';
import SatelliteContent from './views/SatelliteContent';
import Videos from './views/Videos';
import Audio from './views/Audio';
import Images from './views/Images';
import YouTube from './views/YouTube';
import BandBiogContent from './views/BandBiogContent';
import BlogList from './views/BlogList';
import BlogContent from './views/BlogContent';
import FileEditor from './views/FileEditor';
import ArtistTurnover from './views/Admin/ArtistTurnover';
import CreateTestimonial from './views/Admin/CreateTestimonial';
import EditClient from './views/Admin/EditClient';
import BookingsReport from './views/Admin/BookingsReport';
import TurnoverReport from './views/Admin/TurnoverReport';
import './styles/print.scss';
import CreateCustomTestimonial from './views/Admin/CreateCustomTestimonial';
import Testimonials from './views/Admin/Testimonials';
import LoginLayout from './components/Layout/LoginLayout';
import { useRecoilValue } from 'recoil';
import { userState } from './state/RecoilState';

import { ReactNode } from 'react';

const ProtectedRoute = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const user = useRecoilValue(userState);
  if (!user) {
    return <Navigate to={'/login'} replace />;
  }
  return <>{children ? children : <Outlet />}</>;
};

const App = () => {
  return (
    <div className='App'>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route element={<LoginLayout />}>
            <Route path='/login' element={<Login />} />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path='/resetPassword' element={<ResetPassword />} />
            {/* <Route path='/register' element={<Register />} /> */}
          </Route>
          <Route path='/' element={<Layout />}>
            <Route element={<ProtectedRoute />}>
              <Route path='/' element={<DashboardWrapper />} />
              <Route path='/enquiries' element={<Enquiries />} />
              <Route path='/bookings' element={<Bookings />} />
              <Route path='/clients' element={<Clients />} />
              <Route path='/artists' element={<Artists />} />
              <Route path='/styles' element={<Styles />} />
              <Route path='/calendar' element={<Calendar />} />
              <Route path='/booking/edit/:id' element={<EditBooking />} />
              <Route path='/client/edit/:id' element={<EditClient />} />
              <Route path='/createbooking/:id' element={<CreateBooking />} />
              <Route
                path='/artist/edit/:slug'
                element={<EditArtist isAdding={false} />}
              />
              <Route path='/artist/add' element={<EditArtist isAdding />} />
              <Route path='/enquiry/:id' element={<ProcessEnquiry />} />
              <Route
                path='/createtestimoninal/:id'
                element={<CreateTestimonial />}
              />
              <Route
                path='/createtestimoninal'
                element={<CreateCustomTestimonial />}
              />
              <Route path='/testimonials' element={<Testimonials />} />
              <Route path='/showcase/:city' element={<Showcase />} />
              <Route path='/songs' element={<Songs />} />
              <Route path='/videos' element={<Videos />} />
              <Route path='/images' element={<Images />} />
              <Route path='/audio' element={<Audio />} />
              <Route path='/youtube' element={<YouTube />} />
              <Route path='/content' element={<MfsContent />} />
              <Route path='/bloglist' element={<BlogList />} />
              <Route path='/blogcontent/:postRowId' element={<BlogContent />} />
              <Route path='/blogadd' element={<BlogContent />} />
              <Route path='/satellite' element={<SatelliteContent />} />
              <Route path='/biog' element={<BandBiogContent />} />
              <Route path='/files' element={<FileEditor />} />
              <Route path='/artistturnover' element={<ArtistTurnover />} />
              <Route path='/turnoverreport' element={<TurnoverReport />} />
              <Route path='/bookingsreport' element={<BookingsReport />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
